/**
 * Ungated download of the Group Millionaire Strategy guide. A plain link to
 * the static PDF on Firebase Hosting (stable URL, shareable on WhatsApp).
 */
import { Download } from 'lucide-react';
import { trackEvent } from '../../utils/analytics';

export const BROCHURE_URL = '/brochure/propinvest-group-millionaire-strategy.pdf';

interface BrochureDownloadProps {
  source: 'calculator' | 'footer' | 'thank_you' | 'video';
  label?: string;
  variant?: 'solid' | 'outline';
  className?: string;
}

export default function BrochureDownload({
  source,
  label = 'Download the Group Millionaire Strategy guide (PDF)',
  variant = 'solid',
  className = '',
}: BrochureDownloadProps) {
  const look =
    variant === 'solid'
      ? 'bg-primary hover:bg-primary-dark text-white shadow-md'
      : 'border-2 border-primary text-primary hover:bg-primary hover:text-white';
  return (
    <a
      href={BROCHURE_URL}
      download="PropInvest Group Millionaire Strategy.pdf"
      onClick={() => trackEvent('brochure_download', { source })}
      className={`inline-flex items-center justify-center gap-2 font-semibold px-6 py-3 rounded-full transition-colors text-center ${look} ${className}`}
    >
      <Download className="w-5 h-5 shrink-0" aria-hidden="true" />
      <span>{label}</span>
    </a>
  );
}
